(function () {
  document.addEventListener('change', function (event) {
    const option = event.target;
    const group = option.closest('[data-bundle-checkout-options]');
    if (!group || !option.matches('input[type="radio"]') || !option.checked || option.disabled) return;
    const card = group.closest('.product-benefits-grid__card');
    const cta = card && card.querySelector('.product-benefits-grid__cta');
    if (!cta) return;
    cta.href = group.dataset.checkoutEnabled === 'true' && option.value
      ? option.value
      : option.dataset.productUrl || group.dataset.productUrl;

    const image = card.querySelector('img.product-benefits-grid__image');
    const variantImage = option.closest('label').querySelector('template')?.content.firstElementChild;
    if (image && variantImage) image.replaceWith(variantImage.cloneNode(true));
  });

  function attachReviewCounts() {
    document.querySelectorAll('.product-benefits-grid__rating:not([data-count-synced])').forEach((row) => {
      if (row.classList.contains('product-benefits-grid__rating--has-count')) {
        row.setAttribute('data-count-synced', '');
        return;
      }

      const badge = row.querySelector('.jdgm-prev-badge');
      if (!badge) return;

      const count = badge.dataset.numberOfReviews;
      if (!count || count === '0') return;

      if (row.querySelector('.product-benefits-grid__review-count')) {
        row.setAttribute('data-count-synced', '');
        return;
      }

      const countEl = document.createElement('span');
      countEl.className = 'product-benefits-grid__review-count';
      countEl.setAttribute('aria-hidden', 'true');
      countEl.textContent = `(${count})`;
      row.appendChild(countEl);
      row.classList.add('product-benefits-grid__rating--has-count');
      row.setAttribute('data-count-synced', '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachReviewCounts);
  } else {
    attachReviewCounts();
  }

  document.addEventListener('shopify:section:load', attachReviewCounts);
  window.setTimeout(attachReviewCounts, 500);
  window.setTimeout(attachReviewCounts, 1500);
})();
